var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCragheart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "300pt",
    height: "300pt",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 170.621094 138.875 L 235.050781 188.929688 L 270.558594 149.101563 L 208.753906 59.910156 Z M 170.621094 138.875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 147.457031 143.488281 L 183.679688 55.058594 L 152.570313 15.550781 L 85.277344 101.007813 Z M 147.457031 143.488281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 129.355469 161.160156 L 64.917969 111.101563 L 29.441406 150.894531 L 91.246094 240.085938 Z M 129.355469 161.160156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(13.699341%,12.199402%,12.5%)",
      fillOpacity: 1
    },
    d: "M 150.980469 156.554688 L 114.773438 244.9375 L 145.886719 284.445313 L 213.148438 199.03125 Z M 150.980469 156.554688 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCragheart);
export default __webpack_public_path__ + "static/media/Cragheart.e63b6ff03d8c38ac7885f914a7a63cb7.svg";
export { ForwardRef as ReactComponent };